var _class, _DataPreviewSections;
import "core-js/modules/es.array.sort.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import naturalSort from "javascript-natural-sort";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import Mustache from "mustache";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import isDefined from "../../Core/isDefined";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Box from "../../Styled/Box";
import Collapsible from "../Custom/Collapsible/Collapsible";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import MetadataTable from "./MetadataTable";
import { jsx as _jsx } from "react/jsx-runtime";
naturalSort.insensitive = true;
Mustache.escape = function (string) {
  return string;
};

/**
 * CatalogItem-defined sections that sit within the preview description. These are ordered according to the catalog item's
 * order if available.
 */
let DataPreviewSections = observer(_class = (_DataPreviewSections = class DataPreviewSections extends Component {
  sortInfoSections(items) {
    const infoSectionOrder = this.props.metadataItem.infoSectionOrder;
    items.sort(function (a, b) {
      const aIndex = infoSectionOrder.indexOf(a.name);
      const bIndex = infoSectionOrder.indexOf(b.name);
      if (aIndex >= 0 && bIndex < 0) {
        return -1;
      } else if (aIndex < 0 && bIndex >= 0) {
        return 1;
      } else if (aIndex < 0 && bIndex < 0) {
        return naturalSort(a.name, b.name);
      }
      return aIndex - bIndex;
    });
    return items.filter(item => {
      var _item$content, _item$content2;
      return isDefined((_item$content = item.content) !== null && _item$content !== void 0 ? _item$content : item.contentAsObject) && ((_item$content2 = item.content) !== null && _item$content2 !== void 0 ? _item$content2 : item.contentAsObject) !== null && item.content !== "";
    });
  }
  clickInfoSection(reportName, isOpen) {
    const info = this.props.metadataItem.info;
    const clickedInfo = info.find(report => report.name === reportName);
    if (isDefined(clickedInfo)) {
      runInAction(() => {
        clickedInfo.setTrait(CommonStrata.user, "show", isOpen);
      });
    }
    return false;
  }
  render() {
    const metadataItem = this.props.metadataItem;
    const items = metadataItem.hideSource ? metadataItem.infoWithoutSources : metadataItem.info.slice();
    const renderSection = item => {
      let content = item.content;
      try {
        content = Mustache.render(content, metadataItem);
      } catch (error) {
        console.log("FAILED to parse info section ".concat(item.name, " for ").concat(metadataItem.name));
        console.log(error);
      }
      return parseCustomMarkdownToReact(content, {
        catalogItem: metadataItem
      });
    };
    return /*#__PURE__*/_jsx("div", {
      children: this.sortInfoSections(items).map((item, i) => {
        var _item$content3;
        return /*#__PURE__*/_jsx(Box, {
          paddedVertically: true,
          displayInlineBlock: true,
          fullWidth: true,
          children: /*#__PURE__*/_jsx(Collapsible, {
            light: false,
            title: item.name,
            isOpen: item.show,
            onToggle: show => this.clickInfoSection.bind(this, item.name, show)(),
            bodyTextProps: {
              medium: true
            },
            children: ((_item$content3 = item.content) === null || _item$content3 === void 0 ? void 0 : _item$content3.length) > 0 ? renderSection(item) : item.contentAsObject !== undefined && /*#__PURE__*/_jsx(Box, {
              paddedVertically: 3,
              fullWidth: true,
              children: /*#__PURE__*/_jsx(MetadataTable, {
                metadataItem: item.contentAsObject
              })
            })
          }, i)
        }, i);
      })
    });
  }
}, _defineProperty(_DataPreviewSections, "propTypes", {
  metadataItem: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
}), _DataPreviewSections)) || _class;
export default withTranslation()(DataPreviewSections);